import { ChangeDetectionStrategy, Component } from '@angular/core';
import { JsonLdService, MetaService } from '@app/core';
import { JOB_POSTINGS } from '../../constants';

import { CareersBenefitsSectionComponent } from '../careers-benefits-section/careers-benefits-section.component';
import { CareersHeroSectionComponent } from '../careers-hero-section/careers-hero-section.component';
import { CareersJobsSectionComponent } from '../careers-jobs-section/careers-jobs-section.component';
import { CareersValuesSectionComponent } from '../careers-values-section/careers-values-section.component';

@Component({
  selector: 'app-careers',
  templateUrl: './careers.component.html',
  styleUrls: ['./careers.component.scss'],
  standalone: true,
  imports: [
    CareersHeroSectionComponent,
    CareersValuesSectionComponent,
    CareersBenefitsSectionComponent,
    CareersJobsSectionComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CareersComponent {
  constructor(
    private readonly metaService: MetaService,
    private readonly jsonLdService: JsonLdService,
  ) {
    this.metaService.setDescription(
      'Join our global, fully remote team on a mission to build the best mobile SDKs and services for the modern mobile app ecosystem. Discover our values, benefits, and open positions.',
    );
    this.metaService.setTitle('Careers');
    this.metaService.setKeywords([
      'careers',
      'jobs',
      'Capawesome',
      'mobile development',
    ]);
    this.jsonLdService.setStructuredData([
      JsonLdService.buildWebPageSchema(
        'Careers - Capawesome Cloud',
        'Join our global, fully remote team building the best mobile SDKs and services.',
        'https://cloud.capawesome.io/careers/',
      ),
      ...JOB_POSTINGS.map(job => ({
        '@context': 'https://schema.org',
        '@type': 'JobPosting',
        title: job.title,
        description: job.description,
        employmentType: 'FULL_TIME',
        jobLocationType: 'TELECOMMUTE',
        hiringOrganization: {
          '@type': 'Organization',
          name: 'Capawesome',
          sameAs: 'https://cloud.capawesome.io',
        },
        datePosted: job.datePosted,
        baseSalary: {
          '@type': 'MonetaryAmount',
          currency: 'EUR',
          value: {
            '@type': 'QuantitativeValue',
            minValue: job.salaryMin,
            maxValue: job.salaryMax,
            unitText: 'YEAR',
          },
        },
      })),
    ]);
  }
}
